/* eslint-disable max-classes-per-file */
export abstract class ExpressionColumnBasePlainObject {
    public classType: string;
}

export class ExpressionColumnPlainObject extends ExpressionColumnBasePlainObject {
    public static classType: string = 'ExpressionColumnPlainObject';
    public name: string;
    public expression: string;
    public typeExpression?: string;
    public classType = ExpressionColumnPlainObject.classType;
    public transient: boolean;
}

export class ExpressionColumnPatternPlainObject extends ExpressionColumnBasePlainObject {
    public static classType: string = 'ExpressionColumnPatternPlainObject';
    public condition: string;
    public columns: ExpressionColumnPlainObject[] = [];
    public classType = ExpressionColumnPatternPlainObject.classType;
    public typeExpression?: string;
    public unEscapedRegexString: string;
    public hierarchyLevelExpression: string;
}
